export default __webpack_public_path__ + "77df99a97046ee1b4df5200bd0ad0778.png";